module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S3uGGB/tc-custom/9780544935341.jpg?1705549507309",
      "alt": "This image is the cover for the book Delta Wedding and The Ponder Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Delta Wedding and The Ponder Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("These two classic novels by the Pulitzer Prize winning author depict 20th century Southern life “")]), _c('b', [_vm._v("with infinite finesse” ("), _c('i', [_vm._v("The Christian Science Monitor")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Set in 1923, Eudora Welty’s first novel, "), _c('i', [_vm._v("The Delta Wedding")]), _vm._v(", centers around the Fairchild family and their preparations for a wedding at their Mississippi plantation. Drama leads to drama, and the result is a surprising portrait of a large and clamorous Southern family that is “nothing short of riotous” ("), _c('i', [_vm._v("The New Yorker")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("The Ponder Heart")]), _vm._v(", Daniel Ponder of Clay County, Mississippi, is giving away family heirlooms, a watch, and so far, at least one family business. His niece, Edna Earle, has a solution to save the family fortune from Daniel’s mortifying philanthropy: As much as she loves her Uncle Daniel, she’s decided to have him institutionalized in this “wonderful tragicomedy” ("), _c('i', [_vm._v("The New York Times")]), _vm._v(").\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eudora Welty\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0